

import React, { useEffect, useState } from 'react';
import { Container, Grid, TextField, Button, Box, Typography } from '@mui/material';
import toast from "react-hot-toast";

const Profile = () => {
    const [admin, setAdmin] = useState(null);
    const [editable, setEditable] = useState(false);
    const [loading, setLoading] = useState(true);
  const schoolId = localStorage.getItem('schoolId');
  const userId = localStorage.getItem('userId');

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        fetchAdminDetails();
    }, []);

    const fetchAdminDetails = async () => {
        try {
            const response = await fetch(`https://api.isnartecherp.online/api/v1/getSchool?schoolId=${schoolId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch admin');
            }
            const data = await response.json();
            if (data && data.school) {
                setAdmin(data.school[0]);
            }
        } catch (error) {
            toast.error('Error fetching admin:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (prop) => (event) => {
        setAdmin({ ...admin, [prop]: event.target.value });
    };

    const handleSave = async () => {
        try {
            const response = await fetch(`${BACKEND_URL}/api/v1/updateSchoolDetail/${userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    schoolName: admin.schoolName,                  
                    address: admin.address,
                    email: admin.email,
                }),
            });
            if (!response.ok) {
                throw new Error('Failed to update school details');
            }
            toast.success('School Info updated successfully');
            setEditable(false);
        } catch (error) {
            console.error('Error updating admin:', error);
            toast.error('Failed to update profile');
        }
    };

    if (loading) {
        return <TextField fullWidth label="Loading..." disabled />;
    }

    return (
        <Container maxWidth="md" style={{ padding: '20px', marginTop: '20px' }}>
            <Box sx={{ backgroundColor: '#3f51b5', borderRadius: '8px', marginBottom: '20px' }}>
                <Typography
                    variant="h5"
                    align="center"
                    gutterBottom
                    style={{
                        fontWeight: 500,
                        color: '#fff',
                        padding: '8px 0',
                        margin: '0 auto', // Center align within the container
                        maxWidth: '100%', // Ensure it spans the full width of the container
                    }}
                >
                    Update School Information
                </Typography>
            </Box>
            <Grid container spacing={3}>
                <Grid item xs={12} >
                    <TextField
                        fullWidth
                        label="School Name"
                        value={admin.schoolName || ''}
                        onChange={handleChange('schoolName')}
                        disabled={!editable}
                        InputProps={{
                            readOnly: !editable,
                        }}
                        style={{ marginBottom: '20px' }}
                    />
                </Grid>
               
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Address"
                        value={admin.address || ''}
                        onChange={handleChange('address')}
                        disabled={!editable}
                        InputProps={{
                            readOnly: !editable,
                        }}
                        style={{ marginBottom: '20px' }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Email"
                        value={admin.email || ''}
                        onChange={handleChange('email')}
                        disabled={!editable}
                        InputProps={{
                            readOnly: !editable,
                        }}
                        style={{ marginBottom: '20px' }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={editable ? handleSave : () => setEditable(true)}
                    >
                        {editable ? 'Save' : 'Edit'}
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Profile;
